<template>
  <div class="fin-table-footer">
    <span v-if="totalPending">Duke shfaqur {{ from }} - {{ to }}<span v-if="hasMore"> · ka më shumë…</span></span>
    <span v-else>Duke shfaqur {{ from }} - {{ to }} nga {{ total }} rezultate</span>

    <div class="fin-pagination">
      <select class="fin-select" style="width: auto" :value="perPage" @change="$emit('per-page', Number($event.target.value))">
        <option :value="25">25 rreshta</option>
        <option :value="50">50 rreshta</option>
        <option :value="100">100 rreshta</option>
      </select>

      <button type="button" class="fin-page-btn" :disabled="page <= 1" title="Faqja e parë" @click="$emit('page', 1)">
        <i class="fa fa-angle-double-left"></i>
      </button>
      <button type="button" class="fin-page-btn" :disabled="page <= 1" title="Para" @click="$emit('page', page - 1)">
        <i class="fa fa-angle-left"></i>
      </button>
      <template v-if="!totalPending">
        <button v-for="candidate in pageNumbers" :key="candidate" type="button" class="fin-page-btn" :class="{ active: candidate === page }" @click="$emit('page', candidate)">
          {{ candidate }}
        </button>
      </template>
      <span v-else class="fin-page-btn active">{{ page }}</span>
      <button type="button" class="fin-page-btn" :disabled="!canGoNext" title="Pas" @click="$emit('page', page + 1)">
        <i class="fa fa-angle-right"></i>
      </button>
      <button type="button" class="fin-page-btn" :disabled="totalPending || page >= lastPage" title="Faqja e fundit" @click="$emit('page', lastPage)">
        <i class="fa fa-angle-double-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaginationBar",
  props: {
    pagination: { type: Object, default: () => ({}) },
  },
  emits: ["page", "per-page"],
  computed: {
    page() {
      return this.pagination.page || 1;
    },
    perPage() {
      return this.pagination.per_page || 50;
    },
    total() {
      return this.pagination.total == null ? 0 : this.pagination.total;
    },
    totalPending() {
      return this.pagination.total == null;
    },
    hasMore() {
      return !!this.pagination.has_more;
    },
    lastPage() {
      if (this.totalPending) return this.hasMore ? this.page + 1 : this.page;
      return this.pagination.last_page || 1;
    },
    canGoNext() {
      if (this.totalPending) return this.hasMore;
      return this.page < this.lastPage;
    },
    from() {
      const rowHint = this.pagination.row_count;
      if (this.totalPending) {
        return rowHint ? (this.page - 1) * this.perPage + 1 : 0;
      }
      return this.total ? (this.page - 1) * this.perPage + 1 : 0;
    },
    to() {
      if (this.totalPending) {
        const rowHint = this.pagination.row_count || 0;
        if (!rowHint) return 0;
        return (this.page - 1) * this.perPage + rowHint;
      }
      return Math.min(this.total, this.page * this.perPage);
    },
    pageNumbers() {
      const pages = [];
      const start = Math.max(1, Math.min(this.page - 2, this.lastPage - 4));
      const end = Math.min(this.lastPage, start + 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
  },
};
</script>
